import React from 'react';

import useEnterContestModal from './useEnterContestModal';
import EnterContestModal from './EnterContestModal';

export type EnterContestSource = 'default' | 'anonCreateEntry';

type AddEntriesModalProps = {
  contestId: string;
  isOpen: boolean;
  isCloseDisabled?: boolean;
  onClose: () => void;
  onSuccess?: (entryIDs: string[]) => void;
  source?: EnterContestSource;
};

function ConnectedEnterContestModal({
  isOpen,
  contestId,
  isCloseDisabled,
  onClose,
  onSuccess,
  source = 'default',
}: AddEntriesModalProps) {
  const {
    cashBalance,
    creditBalance,
    payWithCredits,
    onPayWithCreditsChange,
    contest,
    createEntriesErrorMessage,
    handleCreateEntries,
    handleOpenDepositModal,
    isCreateEntriesReady,
    nodeRef,
    state,
    promoCardProps,
    voucherError,
    voucherValueInDollars,
  } = useEnterContestModal({
    contestId,
    onClose,
    onSuccess,
    source,
  });

  return (
    <EnterContestModal
      cashBalance={cashBalance}
      creditBalance={creditBalance}
      payWithCredits={payWithCredits}
      onPayWithCreditsChange={onPayWithCreditsChange}
      contest={contest.data}
      createEntriesErrorMessage={createEntriesErrorMessage}
      handleCreateEntries={handleCreateEntries}
      handleOpenDepositModal={handleOpenDepositModal}
      isCloseDisabled={isCloseDisabled}
      isCreateEntriesReady={isCreateEntriesReady}
      isOpen={isOpen}
      isRestartedContest={contest.data?.settings.contestRestart?.isRestarted}
      nodeRef={nodeRef}
      onClose={onClose}
      state={state}
      source={source}
      promoCardProps={promoCardProps}
      voucherError={voucherError}
      voucherValueInDollars={voucherValueInDollars}
    />
  );
}

export default ConnectedEnterContestModal;
